import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/item-banner-create-wallet.png")